import React, { Component } from "react"

import { withStyles } from "@material-ui/core"

import { green } from "@material-ui/core/colors"

import Checkbox from "@material-ui/core/Checkbox"


const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);


export default GreenCheckbox
